// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"styles_toggle-switch__3bTG1","switch":"styles_switch__x6wBJ"};